'use client';
import React from 'react';
import addMonths from 'date-fns/addMonths';

import Layout from '../lib/components/Layout';
import CalendarService from '../lib/services/CalendarService';
import ColumnsDefinition from './ColumnsDef';
import { formatRequestDate, injectLogos } from '../lib/utils';

import { ICalendarProps, IDateRange } from '../lib/interfaces';
import { fetchConferenceCall } from './Services';
import { Conference } from '@benzinga/calendar-manager';

export const ConferenceCallCalendarDef = ColumnsDefinition;
export const fetchConferenceCallData = fetchConferenceCall;

export const ConferenceCallCalendar: React.FC<ICalendarProps> = ({
  calendar,
  calendarData,
  hasStockTableStyling,
  height,
  initialData,
  initialDateRange,
  initialTicker,
  leftSlot,
  onReady,
}) => {
  const [loading, setLoading] = React.useState(false);
  const [tableData, setTableData] = React.useState<Conference[]>(initialData || []);
  let dateRange: IDateRange;

  if (initialDateRange) {
    dateRange = initialDateRange;
  } else {
    dateRange = {
      date_from: formatRequestDate(new Date()),
      date_to: formatRequestDate(addMonths(new Date(), 1)),
    };
  }

  React.useEffect(() => {
    if (calendarData?.serverSide) {
      setTableData(initialData);
    }
  }, [initialData, calendarData]);

  function onTableReady() {
    if (initialData) {
      setTableData(initialData);
    } else {
      const params = {
        'parameters[date_from]': dateRange.date_from,
        'parameters[date_to]': dateRange.date_to,
      };
      if (initialTicker) {
        params['parameters[tickers]'] = initialTicker;
      }
      fetchData(params);
    }

    if (onReady) {
      setTimeout(() => onReady());
    }
  }

  function fetchData(filterParams: any) {
    const query = {
      ...filterParams,
      pagesize: 1000,
    };

    setLoading(true);

    const Calendar = new CalendarService();

    Calendar.getConferenceCalls(query)
      .then(({ data }: any) => {
        const items: any = [];
        if (Array.isArray(data.conference) && data.conference.length) {
          return injectLogos(data.conference);
        }
        return items;
      })
      .then((items: any) => {
        setTableData(items);
        setLoading(false);
      });
  }

  return (
    <Layout
      calendar={calendar}
      // just fixing a build dont know if this works
      calendarData={calendarData}
      columnDefs={ColumnsDefinition}
      enableSearch
      hasStockTableStyling={hasStockTableStyling}
      height={height}
      initialDateRange={dateRange}
      leftSlot={leftSlot}
      onFilterChanged={fetchData}
      onTableReady={onTableReady}
      tableData={tableData}
      tableLoading={loading}
      ticker={initialTicker}
    />
  );
};
